<template lang="pug">
div
  div(v-if="!hasEmailStatus")
    v-layout(row).pl-1.pb-3
      v-icon.mr-2(small color="success") check_circle_outline
      span There is no problem with this email address
  div(v-else)
    v-layout(column).pl-1.pb-3
      span.mb-1 Emails to this address are undeliverable due to:
      .mb-2(v-for="status in statuses")
        v-icon.mr-2(small color="warning") error_outline
        span {{status}}
      span Learn more 
        a(@click="$emit('open-email-status-modal')") here.
</template>

<script>
export default {
  name: 'EmailStatus',
  props: {
    card: {
      required: true,
      default: {}
    },
  },
  computed: {
    statuses() {
      return this.card.fields;
    },
    hasEmailStatus() {
      return this.card.fields && this.card.fields.length;
    },
  },
}
</script>
